import type { PartialLock } from '../../types';
import { Lock } from 'lucide-react';

interface Props {
  partialLock: PartialLock;
}

export function PartialLockDiagram({ partialLock }: Props) {
  return (
    <div className="border-2 border-[#E8943A]/40 rounded-lg p-4 bg-[#E8943A]/[0.03]">
      <div className="flex items-center gap-2 mb-4">
        <Lock className="w-4 h-4 text-[#E8943A]" />
        <h3 className="text-xs font-bold tracking-widest uppercase text-[#E8943A]">
          {partialLock.title}
        </h3>
      </div>

      <div className="flex flex-col gap-3">
        {/* Step 1 */}
        <div className="flex items-start gap-3">
          <div className="w-6 h-6 rounded-full bg-[#E8943A]/20 flex items-center justify-center shrink-0 mt-0.5">
            <span className="text-xs font-bold text-[#E8943A]">1</span>
          </div>
          <p className="text-xs text-white/40">{partialLock.step1}</p>
        </div>

        {/* Arrow */}
        <div className="flex justify-center">
          <div className="w-px h-4 bg-[#E8943A]/30" />
        </div>

        {/* Step 2 */}
        <div className="flex items-start gap-3">
          <div className="w-6 h-6 rounded-full bg-[#E8943A]/20 flex items-center justify-center shrink-0 mt-0.5">
            <span className="text-xs font-bold text-[#E8943A]">2</span>
          </div>
          <p className="text-xs text-white/40">{partialLock.step2}</p>
        </div>
      </div>
    </div>
  );
}
